/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class ModelCreatorService {

        constructor(private baseService: BaseService)
        { }

        public sendToCreate(projectModel: ModelCreatorProjectModel) {
            return this.baseService.post('modelcreator/{companyNumber}/project', projectModel).then((data) => data.data);
        }
    }

    ModelCreatorService.$inject = ['BaseService'];
    angular
        .module('eseebase')
        .service('ModelCreatorService', ModelCreatorService);
}
